import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useCompaniesContext } from '../contexts/CompaniesContext';
import FormMember from './FormMember';

export default function CreateMember() {
  const { modals: { createMember } } = useCompaniesContext();

  return (
    <Modal 
      variant="form"
      isOpen={createMember.isOpen} 
      onClose={createMember.onClose}
    >
      <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Novo membro
            <span>Preencha os dados abaixo:</span>
          </ModalHeader>
          <ModalCloseButton />
          <FormMember />
        </ModalContent>
      
    </Modal>
  )
}